module.exports = __webpack_public_path__ + "static/media/img_pc_home_device.cfdda15b.png";